module.exports = __webpack_public_path__ + "static/media/figure1_v2.195d7ef6.jpg";